import { AxiosInstance } from 'axios'

import { PurchaseAgreementRepository } from './domain'

import { PurchaseAgreement, PurchaseAgreementDetail } from '../../contracts/purchase'
import { AxiosErrorHandler, SolarResponse } from '../../foundation'

export class PartnerPurchaseAgreement implements PurchaseAgreementRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getAgreement = async (term: string): Promise<SolarResponse<PurchaseAgreement>> => {
    try {
      const { data } = await this.axios.request<SolarResponse<PurchaseAgreement>>({
        url: `/partner/v1/purchases/agreements/exist?term=${term}`,
        method: 'get',
      })
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  updateAgreement = async (term: string): Promise<SolarResponse<PurchaseAgreementDetail>> => {
    try {
      const { data } = await this.axios.request<SolarResponse<PurchaseAgreementDetail>>({
        url: `/partner/v1/purchases/agreements`,
        method: 'post',
        data: {
          term,
        },
      })
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
